import { datadogRum } from '@datadog/browser-rum';
import { ENV } from '@constants/env';
import { type CurrentUser } from '@types';

export const setDatadogUser = (user: CurrentUser): void => {
  // Datadog must never run locally.
  if (ENV === 'local') {
    return;
  }

  datadogRum.setUser({
    id: user.userId,
    name: user.userName,
    email: user.email,
    organizationId: user.organizationId,
    roles: user.type,
    isAdmin: user.isAdmin,
    isSdr: user.isSdr,
    isAgent: user.isAgent,
    isSuperAdmin: user.isSuperAdmin,
    isTendrilUser: user.isTendrilUser,
    sdrId: user.sdrId,
    sdrName: user.sdrName,
    timezone: user.timezone,
  });
};

export const clearDatadogUser = (): void => {
  if (ENV === 'local') {
    return;
  }

  datadogRum.clearUser();
};
